// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"SubItem_TheComp__m_y34"};